const cleanLabel = (label = '') => String(label).replace(/\s*\*/g, '').trim();

export const requiredFieldMessage = (t, label) =>
  t('validation.requiredField', { field: cleanLabel(label) });

export const requiredFieldsMessage = (t, labels = []) => {
  const fields = labels.map(cleanLabel).filter(Boolean);
  if (fields.length === 1) return requiredFieldMessage(t, fields[0]);
  return t('validation.reviewRequiredFields', { fields: fields.join(', ') });
};
